import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María', 'Laura', 'Sofía', 'Camila', 'Valentina', 'Martina', 'Lucía', 'Florencia', 'Paula', 'Daniela', 'Julieta', 'Agustina', 'Micaela', 'Carolina', 'Victoria', 'Rocío', 'Josefina', 'Delfina', 'Catalina', 'Milagros', 'Ana', 'Andrea', 'Natalia', 'Mariana', 'Romina', 'Bárbara', 'Guillermina', 'Sol', 'Macarena', 'Lourdes'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes', 'Posadas', 'Paraná', 'Bahía Blanca', 'San Salvador de Jujuy'];
const DEFAULT_THUMB = 'https://cdn.magicpatterns.com/uploads/wkzGFuHWyP7z23EbiJvcUP/heylloyd-image-1772533088855.png';
interface ToastData {
  name: string;
  city: string;
  productName: string;
  priceText: string;
  id: number;
}
function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function pickRandomProduct(): {
  productName: string;
  priceText: string;
} {
  const rand = Math.random();
  if (rand < 0.33) {
    return {
      productName: 'NutriPeques',
      priceText: '$ 20.919 ARS'
    };
  }
  if (rand < 0.66) {
    return {
      productName: 'NutriPeques + 1',
      priceText: '$ 28.956 ARS'
    };
  }
  return {
    productName: 'NutriPeques + 2',
    priceText: '$ 36.188 ARS'
  };
}
function useReducedMotion(): boolean {
  const [prefersReduced, setPrefersReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReduced(mq.matches);
    const handler = (e: MediaQueryListEvent) => setPrefersReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return prefersReduced;
}
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<ToastData | null>(null);
  const recentNamesRef = useRef<string[]>([]);
  const toastIdCounter = useRef(0);
  const shouldReduceMotion = useReducedMotion();
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const showNextToast = () => {
      // Pick name (avoid last 10)
      let availableNames = NAMES.filter(n => !recentNamesRef.current.includes(n));
      if (availableNames.length === 0) availableNames = NAMES;
      const selectedName = getRandomItem(availableNames);
      recentNamesRef.current = [selectedName, ...recentNamesRef.current].slice(0, 10);
      // Pick city
      const selectedCity = getRandomItem(CITIES);
      // Pick product (50/50)
      const {
        productName,
        priceText
      } = pickRandomProduct();
      toastIdCounter.current += 1;
      setToast({
        name: selectedName,
        city: selectedCity,
        productName,
        priceText,
        id: toastIdCounter.current
      });
      // Hide after 4s, then schedule next after 8–15s
      timeoutId = setTimeout(() => {
        setToast(null);
        timeoutId = setTimeout(showNextToast, getRandomInt(8000, 15000));
      }, 4000);
    };
    // Initial delay of 3s
    timeoutId = setTimeout(showNextToast, 3000);
    return () => clearTimeout(timeoutId);
  }, []);
  const animDuration = shouldReduceMotion ? 0 : 0.4;
  return <AnimatePresence data-id="element-400">
      {toast && <motion.div key={toast.id} initial={{
      opacity: 0,
      scale: shouldReduceMotion ? 1 : 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: shouldReduceMotion ? 1 : 0.9
    }} transition={{
      duration: animDuration,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-6 left-0 right-0 mx-auto z-50 pointer-events-none px-4 w-full max-w-sm" data-id="element-401">
          <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 p-3 flex items-center gap-3 w-full max-w-sm" data-id="element-402">
            {/* Thumbnail */}
            <div className="shrink-0 relative" data-id="element-403">
              <img src={DEFAULT_THUMB} alt="NutriPeques" className="w-12 h-12 rounded-xl object-cover shadow-sm border border-gray-50" data-id="element-404" />
              <div className="absolute -bottom-1 -right-1 bg-[#4CAF50] w-4 h-4 rounded-full border-2 border-white flex items-center justify-center" data-id="element-405">
                <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-406">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-407" />
                </svg>
              </div>
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0" data-id="element-408">
              <p className="text-sm text-gray-800 leading-tight" data-id="element-409">
                <span className="font-bold" data-id="element-410">{toast.name}</span> de {toast.city}{' '}
                acaba de comprar
              </p>
              <p className="text-xs text-gray-500 mt-0.5 truncate" data-id="element-411">
                {toast.productName}{' '}
                <span className="font-bold text-[#2E7D32]" data-id="element-412">
                  — {toast.priceText}
                </span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}